<script>
import Base from "@/components/RequestDetails/RequestAttachments.vue";

export default {
  name: "CustomerServiceRequestAttachments",
  extends: Base,
};
</script>

